var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticStyle:{"height":"100vh"},attrs:{"direction":"vertical"}},[_c('Header'),_vm._v(" "),_c('el-container',{attrs:{"direction":"horizontal"}},[_vm._t("sidebar"),_vm._v(" "),_vm._t("main")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }